import $ from 'jquery/src/jquery';
import 'jquery-ui/ui/widgets/accordion';

$(document).ready(function($){
    $('.accordion').each(function(index, element) {
        const $accordion = $(element);
        const $items = $accordion.find('.accordion__item');
        let active = false;
        $items.each(function(index, item) {
            if ( location.hash && $(item).attr('id') === location.hash.substring(1) ) {
                active = index;
            }
        })
        $accordion.accordion({
            active: active,
            collapsible: true,
            heightStyle: "content",
            header: '.accordion__itemHeader',
            beforeActivate: function( event, ui ) {
                //$(ui.oldHeader).parents('.accordion__item').removeClass('active');
                //$(ui.newHeader).parents('.accordion__item').addClass('active');
            },
            activate: function( event, ui ) {
                if(!$.isEmptyObject(ui.newHeader.offset())) {
                    //$('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top - headerHeight - 30 }, 'normal');
                }
            }
        });
    })



    $('.accordion2').accordion({
        active: false,
        collapsible: true,
        heightStyle: "content",
        header: '.accordion2__itemHeader',
        beforeActivate: function( event, ui ) {
            //$(ui.oldHeader).parents('.accordion__item').removeClass('active');
            //$(ui.newHeader).parents('.accordion__item').addClass('active');
        },
        activate: function( event, ui ) {
            if(!$.isEmptyObject(ui.newHeader.offset())) {
                //$('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top - headerHeight - 30 }, 'normal');
            }
        }
    });
});